import { ExpandMore } from '@mui/icons-material';
import { Collapse, Divider, Grid, IconButton } from '@mui/material';
import AlertBanner from 'lib/designSystem/AlertBanner';
import PageHeader from 'lib/designSystem/PageHeader';
import EnhancedTable from 'lib/designSystem/Table';
import { formatDate } from 'lib/functions/utils';
import React, { useState } from 'react';

import GenerateNominee from '../../../../../../../../Financing/Factoring/components/Recieved/components/ShoppingDialog/components/PaymentModule/components/generateNominee';
import {
  IBankAccount,
  IDocument,
  IDocumentStore,
  IPayment,
  IPaymentRequest,
  PaymentType,
} from '../types';

const SELECTED_DOCS_HEADERS = [
  { key: 'folio', label: 'Folio' },
  { key: 'businessName', label: 'Emisor' },
  { key: 'amountToPay', label: 'Monto', type: 'money' },
  {
    key: 'issuedDate',
    label: 'Fecha emisión',
    type: 'date',
    formatter: (value: Date) => formatDate(value, 'dd-mm-yyyy'),
  },
];

const NOMINEE_HEADERS = [
  { key: 'bankAccountOriginName', label: 'Banco origen' },
  { key: 'bankAccountDestinationName', label: 'Banco destino' },
  { key: 'bankAccountDestinationNumber', label: 'N° Cuenta' },
  { key: 'bankAccountDestinationAccountType', label: 'Tipo de cuenta' },
  { key: 'bankAccountDestinationHolderName', label: 'Titular' },
  { key: 'bankAccountDestinationHolderIdentifier', label: 'Rut' },
  { key: 'amount', label: 'Monto', type: 'money' },
  { key: 'executedAt', label: 'Ejecutada', type: 'date' },
];

export interface StepConfigurePaymentProps {
  documents: IDocumentStore;
  paymentType: PaymentType;
  selectedDocuments: number[];
  destinyAccounts: IBankAccount[];
  originAccounts: IBankAccount[];
  payments: IPayment[];
  setPayments: (payments: IPayment[]) => void;
  selectedRequest: IPaymentRequest | null;
  onOpenNonNominee: () => void;
  onReloadAccounts?: () => Promise<boolean>;
}

const StepConfigurePayment: React.FC<StepConfigurePaymentProps> = ({
  documents,
  paymentType,
  selectedDocuments,
  destinyAccounts,
  originAccounts,
  payments,
  setPayments,
  selectedRequest,
  onOpenNonNominee,
  onReloadAccounts,
}) => {
  const [collapseOpen, setCollapseOpen] = useState(true);

  const selectedDocs: IDocument[] = documents[paymentType].filter((doc) =>
    selectedDocuments.includes(doc.id),
  );

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <PageHeader.TitleSection
          title="Documentos"
          subtitle={`${selectedDocs.length} documentos seleccionados`}
          iconType="documents"
        />
        <IconButton onClick={() => setCollapseOpen((prev) => !prev)}>
          <ExpandMore />
        </IconButton>
      </div>

      <Collapse in={collapseOpen} sx={{ mt: 2 }}>
        <EnhancedTable
          data={selectedDocs}
          dataHeaders={SELECTED_DOCS_HEADERS}
          rowsPerPageDefault={5}
        />
      </Collapse>

      <Divider sx={{ my: 2 }} />

      {payments.length === 0 ? (
        <GenerateNominee
          availableAccounts={destinyAccounts}
          originAccounts={originAccounts}
          selectedRequest={selectedRequest}
          setPayments={setPayments}
          amount={selectedRequest?.amount ?? 0}
          onSinNomina={onOpenNonNominee}
          setUp={onReloadAccounts}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EnhancedTable dataHeaders={NOMINEE_HEADERS} data={payments} />
          </Grid>
          <Grid item xs={12}>
            <AlertBanner
              severity="success"
              title="Nómina creada"
              message="Presione finalizar para registrar los pagos"
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default StepConfigurePayment;
